/**
 * Created by JasonChou on 17/1/13.
 */
import { set } from 'jsonuri'
const state = {
  controlDefines: [],
  groupControlDefine: null, //group类型的控件

  controlDefinesMap: {},
  editorHeaderShadowShow: false,
  rulerShow: false,
  rulerLines: [],
  isInit: false,

  services: [], // 三方插件列表
  interfaces: [] // 三方插件接口列表
};

const mutations = {
  SET_DEFINE_MAP (state, k, v) {
    if ( k) {
      set(state.controlDefinesMap, k, v)
    }
  },
  INIT_EDITOR (state, controlDefines, controlVipSettings) {
    // console.log('INIT_EDITOR');
    for (let key in controlDefines) {
      let defines = controlDefines[key];
      if(Array.isArray(defines)) {
        defines.map(controlDefine => {
          if (controlDefine && controlDefine.type)
            state.controlDefinesMap[controlDefine.type] = controlDefine;
        });
      }
    }
    state.groupControlDefine = state.controlDefinesMap['div'];
    const props = {};
    const styles = {};
    const styleCount = {};
    Object.entries(controlVipSettings).map(([key, value]) => {
      props[key] = value.props;
      styles[key] = value.styles;
      styleCount[key] = value.styleCount;
    });
    state.controlVipProps = props;
    state.controlVipStyles = styles;
    state.controlVipStyleCount = styleCount;

    state.controlDefines = controlDefines;
    state.isInit = true;
  },

  SHOW_EDITOR_HEADER_SHADOW (state, show) {
    state.editorHeaderShadowShow = show
  },

  SHOW_RULER (state, show) {
    state.rulerShow = show
  },

  INIT_SERVICE (state, services, interfaces) {
    state.services = services;
    state.interfaces = interfaces;
  },

  /**
   * 新增一个辅助线
   * @param state
   * @param isShowV 是否是X轴的
   * @param count 显示数值
   * @constructor
   */
  NEW_RULER_LINE (state, isShowV, count) {

    let rulerLine = {
      isShowV,
      count
    };
    state.rulerLines.push(rulerLine);
  },

  /**
   * 移除一个辅助线
   * @param state
   * @param rulerLine
   * @constructor
   */
  DELETE_RULER_LINE (state, rulerLine) {
    let index = state.rulerLines.findIndex(line => line == rulerLine);
    if (index != -1) {
      state.rulerLines.splice(index, 1);
    }
  },
  /**
   *
   * 移除所有辅助线
   * @param {*} state
   */
  DELETE_ALL_RULER_LINE (state) {
    state.rulerLines = [];
  },
  /**
   * 移动一个辅助线
   * @param rulerLine 是否是X轴的
   * @param newRulerLine 显示数值
   * @constructor
   */
  MOVE_RULER_LINE (state, rulerLine, newRulerLine) {
    let index = state.rulerLines.findIndex(line => line == rulerLine);
    if (index !== -1) {
      state.rulerLines.splice(index, 1, newRulerLine);
    }
  },

  INIT_CONTROLS_INDEX (state, indexs) {
    for (const controlDefineKey of Object.keys(state.controlDefinesMap)) {
      const controlDefine = state.controlDefinesMap[controlDefineKey];
      controlDefine.index = indexs[controlDefine.type] || 0;
      controlDefine.index += 1;
    }
  },

  CHANGE_CONTROLS_INDEX (state, controlType) {
    state.controlDefinesMap[controlType].index += 1;
  }
};

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/stores/editor.js